// /sources/:id — detail page route.

import { createRoute, useNavigate } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { SourceDetailPage } from "../sources/SourceDetailPage";

export const sourcesDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sources/$id",
  component: SourceDetail,
});

function SourceDetail() {
  const { id } = sourcesDetailRoute.useParams();
  const navigate = useNavigate();
  return <SourceDetailPage id={id} onBack={() => navigate({ to: "/sources" })} />;
}
